import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { ReportContainerDirective } from './containers/report-container.directive';
import { ReportOutputDirective } from './containers/report-output.directive';
import { ReportParametersDefDirective } from './containers/report-parameters-def.directive';
import { ReportParametersComponent } from './containers/report-parameters.component';
import { BarGraphSourceReportParameterComponent } from './parameters/bar-graph-source-report-parameter.component';
import { BooleanReportParameterComponent } from './parameters/boolean-report-parameter.component';
import { AutoAttendantExtensionsReportParameterComponent } from './parameters/data-to-include/auto-attendant-extensions-report-parameter.component';
import { CallDirectionsReportParameterComponent } from './parameters/data-to-include/call-directions-report-parameter.component';
import { CallDispositionsReportParameterComponent } from './parameters/data-to-include/call-dispositions-report-parameter.component';
import { CallQueueExtensionsReportParameterComponent } from './parameters/data-to-include/call-queue-extensions-report-parameter.component';
import { ColumnSortReportParameterComponent } from './parameters/data-to-include/column-sort-report-parameter.component';
import { ExtensionGroupsReportParameterComponent } from './parameters/data-to-include/extension-groups-report-parameter.component';
import { ExtensionSortByReportParameterComponent } from './parameters/data-to-include/extension-sort-by-report-parameter.component';
import { ExtensionsReportParameterComponent } from './parameters/data-to-include/extensions-report-parameter.component';
import { HuntGroupExtensionsReportParameterComponent } from './parameters/data-to-include/hunt-group-extensions-report-parameter.component';
import { PhoneNumbersReportParameterComponent } from './parameters/data-to-include/phone-numbers-report-parameter.component';
import { SortByReportParameterComponent } from './parameters/data-to-include/sort-by-report-parameter.component';
import { TimeRangeReportParameterComponent } from './parameters/data-to-include/time-range-report-parameter.component';
import { DateRangeReportParameterComponent } from './parameters/date-range-report-parameter.component';
import { DateRangeSelectReportParameterComponent } from './parameters/date-range-select-report-parameter.component';
import { DaysOfWeekReportParameterComponent } from './parameters/days-of-week-report-parameter.component';
import { NumberOfCallersReportParameterComponent } from './parameters/number-of-callers-report-parameter.component';
import { SelectedAccountReportParameterComponent } from './parameters/selected-account-report-parameter.component';
import { TimeZoneReportParameterComponent } from './parameters/time-zone-report-parameter.component';
import { DynamicReportParameterDirective } from './report-parameter-list/dynamic-report-parameter.directive';
import { ReportParametersListComponent } from './report-parameter-list/report-parameters-list.component';
import { ReportComponent } from './views/report-component';
import { ReportContextalActionsComponent } from './views/report-contextual-actions.component';
import { ReportHeaderBarComponent } from './views/report-header-bar.component';
@NgModule({
   declarations: [
      ReportComponent,
      ReportHeaderBarComponent,
      ReportContextalActionsComponent,
      ReportParametersComponent,
      CallDirectionsReportParameterComponent,
      CallDispositionsReportParameterComponent,
      ExtensionsReportParameterComponent,
      HuntGroupExtensionsReportParameterComponent,
      ExtensionGroupsReportParameterComponent,
      CallQueueExtensionsReportParameterComponent,
      ColumnSortReportParameterComponent,
      AutoAttendantExtensionsReportParameterComponent,
      PhoneNumbersReportParameterComponent,
      BooleanReportParameterComponent,
      DateRangeReportParameterComponent,
      DateRangeSelectReportParameterComponent,
      TimeZoneReportParameterComponent,
      DaysOfWeekReportParameterComponent,
      SelectedAccountReportParameterComponent,
      NumberOfCallersReportParameterComponent,
      SortByReportParameterComponent,
      TimeRangeReportParameterComponent,
      ExtensionSortByReportParameterComponent,
      BarGraphSourceReportParameterComponent,
      ReportParametersListComponent,
      ReportComponent,
      ReportOutputDirective,
      ReportContainerDirective,
      ReportParametersDefDirective,
      DynamicReportParameterDirective,
   ],
   exports: [
      ReportComponent,
      ReportHeaderBarComponent,
      ReportContextalActionsComponent,
      ReportParametersComponent,
      ExtensionsReportParameterComponent,
      CallQueueExtensionsReportParameterComponent,
      ColumnSortReportParameterComponent,
      AutoAttendantExtensionsReportParameterComponent,
      PhoneNumbersReportParameterComponent,
      CallDirectionsReportParameterComponent,
      BooleanReportParameterComponent,
      DateRangeReportParameterComponent,
      DateRangeSelectReportParameterComponent,
      TimeZoneReportParameterComponent,
      NumberOfCallersReportParameterComponent,
      DaysOfWeekReportParameterComponent,
      SelectedAccountReportParameterComponent,
      ReportParametersListComponent,
      ReportComponent,
      ReportOutputDirective,
      ReportContainerDirective,
      ReportParametersDefDirective,
      DynamicReportParameterDirective,
   ],
   imports: [
      CommonModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      LcsLoadingOverlayModule,
      LcsMultiSelectModule,
      LcsSingleSelectModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatCheckboxModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatRadioModule,
      MatSlideToggleModule,
      MatSelectModule,
      EntitySelectModule,
      ScrollingModule,
      FormatPhoneNumbersPipeModule,
      LcsAdvancedMultiSelectModule,
   ],
})
export class SharedReportsModule {}
